import React from 'react';
import * as S from './Radio.styled';
export const Radio = ({ name, value, checked, disabled, readOnly, tabIndex, inputRef, onChange, onBlur, ...rest }) => (React.createElement(S.Container, null,
    React.createElement(S.Input, { type: "radio", name: name, value: value, ref: inputRef, tabIndex: tabIndex, checked: checked, disabled: disabled, readOnly: readOnly, onChange: onChange, onBlur: onBlur, ...rest }),
    React.createElement(S.Radio, null)));
